'use client';

import { useEffect, useState } from 'react';

export const googleClientId = '189506763495-ctvjm07l1ge9gem6s7egl0hb85pgauvk.apps.googleusercontent.com';

let scriptReady = false;
const readyListeners = new Set<() => void>();
let initialized = false;
let credentialCallback: ((credential: string) => void) | undefined;

export function subscribeGoogleSignInReady(listener: () => void) {
  if (scriptReady) listener();
  readyListeners.add(listener);
  return () => {
    readyListeners.delete(listener);
  };
}

export function setGoogleSignInScriptReady() {
  if (scriptReady) return;
  scriptReady = true;
  readyListeners.forEach((listener) => listener());
}

export function setGoogleSignInCallback(callback: (credential: string) => void) {
  credentialCallback = callback;
}

export function ensureGoogleSignInInitialized() {
  if (initialized || !window.google?.accounts.id) return;

  window.google.accounts.id.initialize({
    client_id: googleClientId,
    callback: (res: { credential: string }) => credentialCallback?.(res.credential),
  });
  initialized = true;
}

export function useGoogleSignInReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => subscribeGoogleSignInReady(() => setReady(true)), []);

  return ready;
}
